import React from "react";

import { type FormikContextType } from "formik";

interface FormikFieldProps<T extends object> {
  formik: FormikContextType<any>;
  name: string;
  Component: React.ComponentType<T>;
  componentProps: Omit<T, "name" | "value" | "onChange" | "onBlur" | "error">;
}

const FormikField = <T extends object>({
  formik,
  name,
  Component,
  componentProps,
}: FormikFieldProps<T>): React.ReactElement => {
  const fieldMeta = formik.getFieldMeta(name);
  const hasError = fieldMeta.touched && !!fieldMeta.error;

  return (
    // @ts-expect-error
    <Component
      name={name}
      value={fieldMeta.value}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={hasError}
      errorText={hasError ? fieldMeta.error : undefined}
      {...componentProps}
    />
  );
};

export default FormikField;
